import { createServiceClient } from "shared/welda/services/axiosClient";

const apiLabels = createServiceClient("/labels");

const GetTemplates = async () => await apiLabels.get("/GetTemplates");

const NewTemplate = async (data) => await apiLabels.post("/newTemplate", data);

const UpdateTemplate = async (data) =>
  await apiLabels.post("/UpdateTemplate", data);

const DeleteTemplate = async (data) =>
  await apiLabels.post("/DeleteTemplate", data);

const labelsService = {
  GetTemplates,
  NewTemplate,
  UpdateTemplate,
  DeleteTemplate,
};

export default labelsService;
